import { Component, OnInit } from '@angular/core';
import { Observable } from 'src/app/classes/observable';
import { MfaService } from 'src/app/service/mfa.service';

@Component({
  selector: 'app-mfaqr',
  templateUrl: './mfaqr.component.html',
  styleUrls: ['./mfaqr.component.scss'],
})
export class MfaqrComponent implements OnInit {

  public manual;
  public qr;
  
  constructor(public MfaService:MfaService) { }

  ngOnInit() {
    this.MfaService.generateMFAQr().then(data =>{
      this.qr = data["qr"];
      this.manual = data["manual"];
      Observable.notify("mfaQrValidate", false);
      Observable.notify("mfaQrActivate", false);
   })  
  }

  onValidate(){
    Observable.notify("mfaQrValidate", true);
    Observable.notify("mfaQrActivate", true);
  }
}
